import { createFileRoute, stripSearchParams } from "@tanstack/react-router";
import { Suspense } from "react";
import { oauthProvidersQueryOptions } from "@/app/oauth/api/get-o-auth-providers";
import { OAuthListSkeleton } from "@/app/oauth/components/oauth-list-skeleton";
import { OAuthList } from "@/app/oauth/list/list";
import { nameFilterSchema } from "@/components/custom/filters/name-filter";
import {
  scopeFilterSearchDefaults,
  scopeFilterSearchSchema,
} from "@/components/custom/resources/scope-filter";

const oauthSearchSchema = nameFilterSchema.extend(
  scopeFilterSearchSchema.shape
);

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/auth/oauth/"
)({
  validateSearch: oauthSearchSchema,
  search: {
    middlewares: [
      stripSearchParams({ name: "", ...scopeFilterSearchDefaults }),
    ],
  },
  component: (): React.JSX.Element => (
    <Suspense fallback={<OAuthListSkeleton />}>
      <OAuthList />
    </Suspense>
  ),
  loader: ({ context: { queryClient }, params }) => {
    queryClient.prefetchQuery(
      oauthProvidersQueryOptions({ binding: "project", scope: params })
    );
  },
});
